import MenuIcon from "@mui/icons-material/Menu";
import React, { useEffect, useState } from "react";
import ReactDOM from "react-dom/client";
import { Link, Route, HashRouter as Router, Routes, useLocation } from "react-router-dom";
import AotenjiuuCalculateTrainer from "./pages/AotenjiuuCalculateTrainer";
import CalculateShanten from "./pages/CalculateShanten";
import CommentsPage from "./pages/CommentsPage";
import Cut300Trainer from "./pages/Cut300Trainer";
import EfficiencyTrainer from "./pages/EfficiencyTrainer";
import FuCalculateTrainer from "./pages/FuCalculateTrainer";
import HandPointsCalculateTrainer from "./pages/HandPointsCalculateTrainer";
import MainPage from "./pages/MainPage";
import PointsCalculateTrainer from "./pages/PointsCalculateTrainer";
import PureOnesEfficiencyTrainer from "./pages/PureOnesEfficiencyTrainer";
import PureOnesReadyTrainer from "./pages/PureOnesReadyTrainer";
import reportWebVitals from "./reportWebVitals";
import HanCalculateTrainer from "./pages/HanCalculateTrainer";

const root = ReactDOM.createRoot(document.getElementById("root"));

const App = () => {
    const [isMenuOpen, setIsMenuOpen] = useState(false);

    useEffect(() => {
        const handleClickOutside = (e) => {
            if (isMenuOpen && !e.target.closest("nav")) {
                setIsMenuOpen(false);
            }
        };

        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, [isMenuOpen]);

    return (
        <React.StrictMode>
            <Router>
                <div>
                    <Navigation isMenuOpen={isMenuOpen} setIsMenuOpen={setIsMenuOpen} />
                    {isMenuOpen && (
                        <div
                            style={{
                                position: "fixed",
                                top: 0,
                                left: 0,
                                width: "100%",
                                height: "100%",
                                backgroundColor: "rgba(0, 0, 0, 0.5)", // 半透明黑色
                                zIndex: 999, // 確保在選單下方
                            }}
                            onClick={() => setIsMenuOpen(false)} // 點擊背景時關閉選單
                        />
                    )}
                    <Routes>
                        <Route path="/" element={<MainPage />} />
                        <Route path="/calculate-shanten" element={<CalculateShanten />} />
                        <Route path="/efficiency-trainer" element={<EfficiencyTrainer />} />
                        <Route path="/pure-ones-efficiency-trainer" element={<PureOnesEfficiencyTrainer />} />
                        <Route path="/pure-ones-ready-trainer" element={<PureOnesReadyTrainer />} />
                        <Route path="/cut-300-trainer" element={<Cut300Trainer />} />
                        <Route path="/points-calculate-trainer" element={<PointsCalculateTrainer />} />
                        <Route path="/aotenjiuu-calculate-trainer" element={<AotenjiuuCalculateTrainer />} />
                        <Route path="/fu-calculate-trainer" element={<FuCalculateTrainer />} />
                        <Route path="/han-calculate-trainer" element={<HanCalculateTrainer />} />
                        <Route path="/hand-points-calculate-trainer" element={<HandPointsCalculateTrainer />} />
                        <Route path="/comments" element={<CommentsPage />} />
                    </Routes>
                    <div style={{ marginTop: "20px" }}></div>
                </div>
            </Router>
        </React.StrictMode>
    );
};

const Navigation = ({ isMenuOpen, setIsMenuOpen }) => {
    const location = useLocation();
    const pageTitles = ["首頁", "進張數計算", "牌效率何切", "清一色何切", "清一色聽牌", "何切 300 問", "點數計算", "青天井計算", "符數計算", "飜數計算", "手牌算點", "留言區"];
    const paths = [
        "/",
        "/calculate-shanten",
        "/efficiency-trainer",
        "/pure-ones-efficiency-trainer",
        "/pure-ones-ready-trainer",
        "/cut-300-trainer",
        "/points-calculate-trainer",
        "/aotenjiuu-calculate-trainer",
        "/fu-calculate-trainer",
        "/han-calculate-trainer",
        "/hand-points-calculate-trainer",
        "/comments",
    ];

    return (
        <nav style={{ position: "relative", padding: "10px" }}>
            {/* 選單按鈕 */}
            <button
                onClick={() => setIsMenuOpen(!isMenuOpen)}
                style={{
                    background: "#FFFFFF",
                    color: "#000000",
                    border: "1px solid #000000",
                    borderRadius: "5px",
                    padding: "8px 16px",
                    fontSize: "18px",
                    fontWeight: "bold",
                    cursor: "pointer",
                    display: "flex",
                    alignItems: "center",
                }}
            >
                <MenuIcon />
                <div style={{ marginLeft: "5px" }}>菜單</div>
            </button>

            {/* 下拉菜單 */}
            {isMenuOpen && (
                <div
                    style={{
                        position: "fixed",
                        top: 0,
                        left: 0,
                        right: 0,
                        backgroundColor: "white",
                        boxShadow: "0 2px 10px rgba(0,0,0,0.1)",
                        borderRadius: "5px",
                        zIndex: 1000,
                        padding: "10px",
                    }}
                >
                    <div
                        style={{
                            fontSize: "24px",
                            fontWeight: "bold",
                            borderRadius: "4px",
                            textAlign: "center",
                            backgroundColor: "#FFFFFF",
                            color: "#007BFF",
                            margin: "10px",
                            cursor: "default", // 避免使用者以為可以點擊
                        }}
                    >
                        菜單列表
                    </div>
                    <ul
                        style={{
                            listStyle: "none",
                            padding: 0,
                            margin: 0,
                            display: "grid",
                            gridTemplateColumns: "repeat(auto-fit, minmax(120px, 1fr))",
                            gap: "10px",
                            textAlign: "center",
                        }}
                    >
                        {paths.map((path, index) => {
                            const isActive = location.pathname === path;

                            return (
                                <li key={path}>
                                    <Link
                                        to={path}
                                        style={{
                                            textDecoration: "none",
                                            fontSize: "18px",
                                            fontWeight: "bold",
                                            borderRadius: "4px",
                                            padding: "8px",
                                            display: "block",
                                            textAlign: "center",
                                            transition: "background-color 0.3s, color 0.3s, border-color 0.3s",
                                            border: "1px solid #007BFF",
                                            backgroundColor: isActive ? "#007BFF" : "#FFFFFF",
                                            color: isActive ? "white" : "#007BFF",
                                        }}
                                        onMouseEnter={(e) => {
                                            e.target.style.backgroundColor = "#007BFF";
                                            e.target.style.color = "white";
                                        }}
                                        onMouseLeave={(e) => {
                                            if (!isActive) {
                                                e.target.style.backgroundColor = "#FFFFFF";
                                                e.target.style.color = "#007BFF";
                                            }
                                        }}
                                        onClick={() => setIsMenuOpen(false)}
                                    >
                                        {pageTitles[index]}
                                    </Link>
                                </li>
                            );
                        })}
                    </ul>
                </div>
            )}
        </nav>
    );
};

root.render(<App />);

reportWebVitals();
